export default "__VITE_ASSET__9V_00o6y__"